import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05cd3370"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "header"
}

import { IHeadersTable } from '@/types';
import { withDefaults, watch, defineAsyncComponent, ref, computed } from 'vue';
interface IProps {
  items: any[];
  headers: IHeadersTable[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeListActions',
  props: {
    items: null,
    headers: null
  },
  setup(__props: any) {

const props = __props as { items: any[], headers: IHeadersTable[] };



function validateInformation(item: any, key: string) {

  let obj = '';
  key.split(".").map(f => {
    obj = !obj ? item[f] : obj[f];
  });


  return obj;


}

const headersComputed = computed(() => {
  return props.headers.filter(f => f.field != 'actions');
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, idx) => {
      return (_openBlock(), _createElementBlock("li", {
        key: idx + 'it',
        class: "py-5 d-flex align-center justify-space-around"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headersComputed), (head, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: String(index)
          }, [
            (head.type == 'image')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  alt: "SO",
                  class: "img-so",
                  src: validateInformation(item, head.field)
                }, null, 8, _hoisted_1))
              : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(head.label) + ":" + _toDisplayString(validateInformation(item, head.field)), 1))
          ], 64))
        }), 128)),
        (__props.headers.find(f => f.field == 'actions'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.$slots.actions)
                ? _renderSlot(_ctx.$slots, "actions", {
                    key: 0,
                    data: item
                  })
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})